import {KnowledgeDefinitionKind} from "../knowledge/knowledgeDefinitionsApi";

/** Wording that differs between the knowledge types and the attributes screens. */
export interface KnowledgeDefinitionLabels {
    singular: string;
    capitalised: string;
    namePlaceholder: string;
    descriptionPlaceholder: string;
    descriptionHint: string;
    /** Shown while editing: a definition is shared, so a change reaches every record using it. */
    updateNoticeTitle: string;
    updateNotice: string;
    deleteWarning: string;
    emptyState: string;
}

export const KNOWLEDGE_DEFINITION_LABELS: Record<KnowledgeDefinitionKind, KnowledgeDefinitionLabels> = {
    [KnowledgeDefinitionKind.TYPE]: {
        singular: "knowledge type",
        capitalised: "Knowledge type",
        namePlaceholder: "Warranty extras",
        descriptionPlaceholder: "Extended warranty products, what they cover and how to buy them",
        descriptionHint: "Aime reads the description to decide which type of knowledge answers a question.",
        updateNoticeTitle: "Changes apply everywhere this knowledge type is used",
        updateNotice: "The new name, key and description apply to every knowledge record of this type, across all "
            + "assistants, franchises and locations. Aime uses the updated description to decide when to pick it.",
        deleteWarning: "A knowledge type that is still used by knowledge records cannot be deleted.",
        emptyState: "No custom knowledge types yet. Create one to group knowledge beyond the built-in types."
    },
    [KnowledgeDefinitionKind.ATTRIBUTE]: {
        singular: "attribute",
        capitalised: "Attribute",
        namePlaceholder: "Vehicle brand",
        descriptionPlaceholder: "The vehicle brand the knowledge applies to",
        descriptionHint: "Aime reads the description to decide when an attribute is relevant to a question.",
        updateNoticeTitle: "Changes apply everywhere this attribute is used",
        updateNotice: "The new name, key and description apply to every knowledge record that carries this attribute, "
            + "across all assistants, franchises and locations. The values already set on records stay as they are.",
        deleteWarning: "The attribute will be removed from every knowledge record that uses it.",
        emptyState: "No attributes yet. Create one to tag knowledge records with extra details."
    }
};
